import ninegrid from "../index.js";

export class ngCellCopyPasteKeyHandler
{
	#owner;
	
	constructor(owner) {
		this.#owner = owner;

		$(this.#owner.body).on("keydown", this.#onKeyDown);
	};
	
	
	
	#onKeyDown = e => {
		
		if (!e.ctrlKey && !e.metaKey) return;
		
		if (["C","c"].includes(e.key)) {
			this.#copy();
		}
		else if (["V","v"].includes(e.key)) {
			this.#paste();
		}
	}
	
	#paste = () => {

		const currentCell = this.#owner.cell.currentCell;
		if (!currentCell) return;
		if (!this.#owner.selection.rows[0]) return;
		if (currentCell.dataset.row != this.#owner.selection.rows[0]) return;
		
		const row = parseInt(currentCell.dataset.row);
		const col = parseInt(currentCell.dataset.row);
		
		navigator.clipboard.readText()
			.then(text => {
				text.split('\n').forEach(line => {
					line.split('\t').forEach(v => {
						//console.log(v);
					});
				});
			})
			.catch(err => {
				console.error('Failed to read clipboard contents: ', err);
			});
	}
	
	#copy = () => {
			
		const clipboardData = [];
		for (var i = this.#owner.selection.selected.startRow; i <= this.#owner.selection.selected.endRow; i++) {
	
			var rowData = [];
			for (var j = this.#owner.selection.selected.startCol; j <= this.#owner.selection.selected.endCol; j++) {
				rowData.push(this.#getDisplayValue(i, j));
			}
			
			clipboardData.push(rowData.join("\t"));
		}
		
		if (clipboardData.length <= 0) return;
	
		/**
		const ta = document.createElement("textarea");
		ta.value = clipboardData.join("\n");
		document.body.appendChild(ta);
		ta.select();
		document.execCommand("copy");
		document.body.removeChild(ta);
		*/
		
		
		navigator.clipboard.writeText(clipboardData.join("\n"))
			.then(() => {
				//ninegrid.j.querySelectorAll(".copied", this.#owner.body).removeClass("copied");
				setTimeout(() => {
					ninegrid.j.querySelectorAll(".selected", this.#owner.body).addClass("copied");
				});
				
				setTimeout(() => {
					ninegrid.j.querySelectorAll(".copied", this.#owner.body).removeClass("copied");
				}, 1000);
			})
			.catch(err => {
				console.error('Failed to copy text: ', err);
			});
	};
	
	#getDisplayValue = (matrixRow, col) => {
		const row	= parseInt(matrixRow / this.#owner.template.length);
		const tr	= this.#owner.template[matrixRow % this.#owner.template.length];
		const cell	= tr.querySelector(`[data-col="${col}"]`);
		
		if (!cell || !cell.dataset) return "";
		
		if (cell.dataset.expr) {
			return this.#owner.exprFunction(cell.dataset.expr).call(this, this.#owner.data.get(row), row);
		}
		else if (cell.dataset.bind) {
			return this.#owner.data.get(row, cell.dataset.bind);
		}
	};
}